import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import { Link } from "react-router-dom";

const blogEditEndpoint = ApiEndpoints.adminBlogs.blogEdit;
const blogUpdateEndpoint = ApiEndpoints.adminBlogs.blogUpdate;
const userName = !localStorage.getItem("username")
  ? "Admin"
  : localStorage.getItem("username");

export default function EditBlog() {
  const navigate = useNavigate();
  const { blog_id } = useParams();

  const [previews, setPreviews] = useState({
    image: null,
    section_image: null,
    section_image2: null,
    section_image3: null,
  });

  const [postData, setPostData] = useState({
    category_id: "",
    author_id: "",
    tag1: "",
    listing_page_description: "",
    short_description: "",
    name: "",
    slug: "",
    image: null,
    section_image: null,
    section_image2: null,
    section_image3: null,
    createdBy: userName,
    date: new Date(),
    description1: "",
    description2: "",
    heading1: "",
    heading2: "",
  });

  const [sectionIds, setSectionIds] = useState([1, 2]);
  const [data, setData] = useState({
    blog: {},
    categories: [],
    authors: [],
    tags: [],
  });

  const isTranslationField = (key) => key.toLowerCase().startsWith("translation");

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await ApiRequest("GET", `${blogEditEndpoint}${blog_id}`);
  //       setData(response);
  //       const blogData = response.blog || {};

  //       // ✅ Filter headings/descriptions that are not empty/null/undefined
  //       const validSections = Object.entries(blogData)
  //         .filter(
  //           ([key, value]) =>
  //             (key.startsWith("heading") || key.startsWith("description")) &&
  //             value !== null &&
  //             value !== undefined &&
  //             value.toString().trim() !== ""
  //         )
  //         .reduce((acc, [key, value]) => {
  //           acc[key] = value;
  //           return acc;
  //         }, {});

  //       // ✅ Determine which sections actually exist
  //       const existingIds = Array.from(
  //         new Set(
  //           Object.keys(validSections)
  //             .filter((key) => key.startsWith("heading"))
  //             .map((key) => parseInt(key.replace("heading", ""), 10))
  //         )
  //       );

  //       const sectionList =
  //         existingIds.length > 0 ? existingIds.sort((a, b) => a - b) : [1, 2];

  //       // ✅ Merge with defaults to preserve structure
  //       const mergedData = { ...postData, ...blogData };
  //       setPostData(mergedData);
  //       setSectionIds(sectionList);

  //       // ✅ Preview images
  //       setPreviews({
  //         section_image: blogData.section_image
  //           ? BaseUrl + blogData.section_image
  //           : null,
  //         image: blogData.image ? BaseUrl + blogData.image : null,
  //         section_image2: blogData.section_image2
  //           ? BaseUrl + blogData.section_image2
  //           : null,
  //         section_image3: blogData.section_image3
  //           ? BaseUrl + blogData.section_image3
  //           : null,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching blog data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [blog_id]);

  // ---------------------- HANDLERS ----------------------


  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", `${blogEditEndpoint}${blog_id}`);
      setData(response);
      const blogData = response.blog || {};

      // ✅ Filter: keep only headings/descriptions that are NOT null, undefined, or empty
      const validSections = Object.fromEntries(
        Object.entries(blogData).filter(([key, value]) => {
          if (isTranslationField(key)) {
            return false;
          }
          if (key.startsWith("heading") || key.startsWith("description")) {
            return (
              value !== null &&
              value !== undefined &&
              value.toString().trim() !== ""
            );
          }
          return true; // keep other (non-heading/description) fields
        })
      );

      // ✅ Find which heading IDs actually exist
      const existingIds = Array.from(
        new Set(
          Object.keys(validSections)
            .filter((key) => key.startsWith("heading"))
            .map((key) => parseInt(key.replace("heading", ""), 10))
        )
      );

      // ✅ Use only valid section IDs
      const sectionList =
        existingIds.length > 0 ? existingIds.sort((a, b) => a - b) : [];

      // ✅ Set filtered data only (no empty headings/descriptions)
      setPostData(validSections);
      setSectionIds(sectionList);

      // ✅ Preview images
      setPreviews({
        section_image: blogData.section_image
          ? BaseUrl + blogData.section_image
          : null,
        image: blogData.image ? BaseUrl + blogData.image : null,
        section_image2: blogData.section_image2
          ? BaseUrl + blogData.section_image2
          : null,
        section_image3: blogData.section_image3
          ? BaseUrl + blogData.section_image3
          : null,
      });
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  fetchData();
}, [blog_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      const file = files[0];
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const handleAddMore = (e) => {
    e.preventDefault();
    const nextId = Math.max(...sectionIds) + 1;
    if (nextId > 10) {
      toast.warning("You can only add up to 10 sections.");
      return;
    }

    setSectionIds((prev) => [...prev, nextId]);
    setPostData((prev) => ({
      ...prev,
      [`heading${nextId}`]: "",
      [`description${nextId}`]: "",
    }));
  };

  const handleRemove = (id) => {
    if (id <= 2) return;

    setSectionIds((prev) => prev.filter((num) => num !== id));
    setPostData((prev) => {
      const newData = { ...prev };
      delete newData[`heading${id}`];
      delete newData[`description${id}`];
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (isTranslationField(key)) continue;
      if (!["brief", "listing_page_description", "short_description"].includes(key) && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (isTranslationField(key)) return;
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest( "POST",  blogUpdateEndpoint + blog_id,
        formData,
        {  headers: {   "Content-Type": "multipart/form-data",  },
        }
      );
      if (response.error) {
        toast.error(response.message);
        return;
      }
      toast.success(response.message);
      navigate("/blog");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to update blog.");
    }
  };

  const pagename = {
    name: "Blog Management",
    user: "Admin",
    innerpage: "Blog Management / Blog / Edit Blog",
  };

  // ---------------------- RENDER ----------------------

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="blogEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      title<small>*</small>
                    </label>
                  </div>
                  <input
                    value={postData.name || ""}
                    onChange={handleChange}
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Enter Title"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      slug<small>*</small>
                    </label>
                  </div>
                  <input
                    value={postData.slug || ""}
                    onChange={handleChange}
                    name="slug"
                    type="text"
                    className="form-control"
                    placeholder="Enter Slug"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      category<small>*</small>
                    </label>
                  </div>
                  <CustomSelect
                    defaultValue={postData.category_id}
                    onChange={handleChange}
                    name={"category_id"}
                    options={data.categories}
                    placeholder="Select Category"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      Date<small>*</small>
                    </label>
                  </div>
                  <input
                    value={
                      postData.date
                        ? new Date(postData.date).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={handleChange}
                    name="date"
                    type="date"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      Author Name<small>*</small>
                    </label>
                  </div>
                  <CustomSelect
                    defaultValue={postData.author_id}
                    onChange={handleChange}
                    name="author_id"
                    options={data.authors}
                    placeholder="Select Author Name"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      Tag Name<small>*</small>
                    </label>
                  </div>
                  <CustomSelect
                    defaultValue={postData.tag1}
                    onChange={handleChange}
                    name="tag1"
                    options={data.tags}
                    placeholder="Select Tag Name"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Listing Page Description</label>
                  </div>
                  <input
                    onChange={handleChange}
                    name="listing_page_description"
                    type="text"
                    className="form-control"
                    placeholder="Enter Listing Page Description"
                    value={postData.listing_page_description || ""}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Short Description</label>
                  </div>
                  <input
                    onChange={handleChange}
                    name="short_description"
                    type="text"
                    className="form-control"
                    placeholder="Enter Short Description"
                    value={postData.short_description || ""}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Render only existing heading sections */}
          <div className="add-content-wrap">
            <div className="row">
              {sectionIds.map((id) => (
                <div key={id} className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                      <label>
                        Heading {id}
                        {id <= 2 && <small>*</small>}
                      </label>
                      {id > 2 && (
                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => handleRemove(id)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                    <input
                      onChange={handleChange}
                      name={`heading${id}`}
                      type="text"
                      className="form-control"
                      placeholder="Enter Heading"
                      value={postData[`heading${id}`] || ""}
                    />
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>
                        Description {id}
                        {id <= 2 && <small>*</small>}
                      </label>
                    </div>
                    <DynamicCKEditor
                      data={postData[`description${id}`] || ""}
                      onChange={(event, editor) =>
                        handleEditorChange(`description${id}`, editor.getData())
                      }
                    />
                  </div>
                </div>
              ))}

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link
                    className="addmore-images-client"
                    onClick={handleAddMore}
                  >
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Images */}
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Banner Image (1200 × 638)<small>*</small> </label>
                  </div>
                  <CustomImageUpload
                    name="section_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section_image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Listing Image (400 × 480)<small>*</small>  </label>
                  </div>
                  <CustomImageUpload
                    name="image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>
                      Image 1 (580 × 446)<small>*</small>
                    </label>
                  </div>
                  <CustomImageUpload
                    name="section_image2"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section_image2}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>
                      Image 2(580 × 446)<small>*</small>
                    </label>
                  </div>
                  <CustomImageUpload
                    name="section_image3"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section_image3}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="blogEdit" className="default-btn">
          publish <span></span>
        </button>
      </div>
    </>
  );
}
